module.exports = __webpack_public_path__ + "static/img/7.31d955c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/7.png
// module id = Y6no
// module chunks = 0